import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.index-of.js";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import event from '../event';
var Event = event.Event;
var HOST = location.host;
var envList = ['test', 'ppe', 'staging', 'product'];
var TEST = envList[0],
  PPE = envList[1],
  STAGING = envList[2],
  PRODUCT = envList[3];
var Env = /*#__PURE__*/function (_Event) {
  _inherits(Env, _Event);
  var _super = _createSuper(Env);
  function Env(env) {
    var _this;
    _classCallCheck(this, Env);
    _this = _super.call(this);
    _this.disabled = false;
    _this.envList = envList;
    _this.env = _this.getEnvByHost();
    if (env) {
      _this.set(env);
    }
    return _this;
  }
  _createClass(Env, [{
    key: "getEnvByHost",
    value: function getEnvByHost() {
      var env = PRODUCT;
      if (/^ppe./.test(HOST)) env = PPE;
      if (/.test.maoyan.com|.51ping.com|localhost|1\d{2}\./.test(HOST)) env = TEST;
      return env;
    }
  }, {
    key: "get",
    value: function get() {
      return this.env;
    }
  }, {
    key: "set",
    value: function set(env) {
      if (this.disabled) return;
      if (this.envList.indexOf(env) === -1) {
        env = PRODUCT;
      }
      if (this.env !== env) {
        this.trigger('envChanged', env);
      }
      this.env = env;
    }
  }, {
    key: "disable",
    value: function disable() {
      this.disabled = true;
      this.env = PRODUCT;
    }
  }, {
    key: "isProduct",
    get: function get() {
      return this.env === PRODUCT;
    }
  }, {
    key: "isTest",
    get: function get() {
      return this.env === TEST;
    }
  }, {
    key: "isPpe",
    get: function get() {
      return this.env === PPE;
    }
  }, {
    key: "environment",
    get: function get() {
      return this.env;
    }
  }, {
    key: "isLocal",
    get: function get() {
      return /^(localhost|[0-9]{1,3})/.test(HOST);
    }
  }]);
  return Env;
}(Event);
export default new Env();